import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import DatePickerComponent from "../../components/Datepicker";
import PersonalContext from "./PersonalContext";
import SelectComponent from "../../components/Select";
import ProvincesComponent from "../../components/Provinces";
import PaymentErrorModalComponent from "../../components/PaymentErrorModal";
import { TITLES, RELATIONS } from "../../data/global";
import InputMask from "react-input-mask";
import { DateUtils } from "../../utils";
import { DATETIME_SEARCH_FORMAT } from "../../const";
import AddRound from "../../images/add_round.svg";
import DelRound from "../../images/del_round.svg";
import { Alert } from "../../utils";
import moment from "moment";
import { SpaceBox } from "../../components/Space";
import { Step3Langague } from "../../data/locale";
import CheckBoxHealth from "../../components/CheckBoxHealth";
import DataService from "../../service/data";
import NameThComponent from "../../components/Customer/NameTh";
import InfoIconComponent from "../../components/InfoIcon";
// import ContactFormModalComponent from "../../components/ContactFormModal";
// const str = 'football@.co.th';
// const regex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
// console.log(regex.test(str));

class PersonalStep2 extends Component {
  state = {
    benefitTitles: [],
    nationals: [],
    coverDetails: []
  };
  titles = [];

  constructor(props) {
    super(props);
    setTimeout(() => {
      this.initData();
    }, 1);
  }

  async initData() {
    try {
      const callers = [];
      callers.push(DataService.getTitle({ lang: "", type: "B" }));
      callers.push(DataService.getNationalities());
      callers.push(DataService.getOccupations());
      console.log("occupations", DataService.getOccupations());
      // callers.push(
      //   DataService.getCoverDetails({
      //     product_code: "MTI06113",
      //     package_code: "PA101",
      //     cust_order: "1"
      //   })
      // );

      const responses = await Promise.all(callers);
      this.titles = responses[0];
      const benefitTitles = this.titles.filter(data => data.lang === "TH");

      this.setState({
        ...this.state,
        benefitTitles: benefitTitles,
        nationals: responses[1],
        occupations: responses[2]
        // ,
        // coverDetails: responses[3]
      });
    } catch (err) {
      console.log(err);
    }
  }
  _getTitles(sSex, lang) {
    return this.titles.filter(
      title => title.gender === sSex && title.lang === lang
    );
  }
  _getLang(field) {
    const lang = 2 === 1 ? "en" : "th";
    return Step3Langague[field][lang];
  }

  _onSelectOccupation = selected => {
    const { onChangeModel, onNavigate } = this.context.step2;
    console.log('onselect occupation',selected);
    if (selected && selected.isRisk) {  
      selected.isRisk = parseInt(selected.isRisk);
    }
    if (selected && selected.isRisk) {
      const handleClickClose = () =>
      {
        Alert.hideLoading();
      };

      Alert.alertMessage(
        "กรุณากรอกข้อมูลให้ถูกต้อง",
        "อาชีพที่ระบุเป็นอาชีพที่ประกันไม่คุ้มครอง",
        "warning",
        "true",
        "ติดต่อเจ้าหน้าที่",
        "true",
        "ยกเลิก",
      )
        .then(res => {
        if (res === "option1") {
          onNavigate(6);
        }
      });
    } else {
      onChangeModel({ name: "sOccupation", value: selected });
    }
  };
  _renderRelationForm() {
    const { step2 } = this.context;
    const {
      onChangeModel,
      sAssuranceFor,
    } = step2;
    return (
    <div className="form-group">
      <label>{this._getLang("assuranceFor")}{" "}
        <InfoIconComponent id="assuranceFor" text="ความสัมพันธ์กับผู้เอาประกันภัยทั้งในเชิงนิตินัย และพฤตินัย" />
      </label>
      <div className="d-flex">
        <div
          className={`radio-button align-item-center ${
            sAssuranceFor === "self" ? "active" : ""
          }`}
          onClick={() => {
            onChangeModel({ name: "sAssuranceFor", value: "self" })
            onChangeModel({ name: "sAssuranceRelation", value: "" })
          }}
        >
          <div className="radio" />
          <p>{this._getLang("forSelf")}</p>
        </div>
        <div
          className={`radio-button align-item-center ${
            sAssuranceFor === "other" ? "active" : ""
          }`}
          onClick={() => onChangeModel({ name: "sAssuranceFor", value: "other" })}
        >
          <div className="radio" />
          <p>{this._getLang("otherPeople")}</p>
        </div>
      </div>
    </div>
    )
  }
  _renderBuyerForm() {
    const { diffDateAssurance, step2 } = this.context;
    const regex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
    const {
      onChangeModel,
      sAssuranceFor,
      sAssuranceRelation,
      BuyerInitNameTH,
      BuyerFirstNameTH,
      BuyerLastNameTH
    } = step2;

    const { benefitTitles } = this.state;
    return (
      <Fragment>
        {/* ################## */}
        {/** Start AssuranceRelation **/}
        {/* ################## */}
          <div className="form-group">
            <label>ข้อมูลของตนเอง/ความสัมพันธ์ต่อผู้เอาประกัน</label>
            <SelectComponent
              placeholder="โปรดเลือก"
              options={RELATIONS}
              selected={sAssuranceRelation}
              onChange={selected =>
                onChangeModel({ name: "sAssuranceRelation", value: selected })
              }
              disabled={sAssuranceFor !== 'other'}
            />
          </div>
        {/* ################### */}
        {/** Start ผู้ซื้อประกันภัย **/}
        {/* ################### */}
          <NameThComponent
            keyIndex={""}
            label="ชื่อ/นามสกุล ผู้ซื้อประกันภัย (ภาษาไทย)"
            titles={benefitTitles}
            sInitNameTH={BuyerInitNameTH}
            sFirstNameTH={BuyerFirstNameTH}
            sLastNameTH={BuyerLastNameTH}
            onChange={onChangeModel}
            options={{initKey: 'BuyerInitNameTH', firstNameKey: 'BuyerFirstNameTH', lastNameKey: 'BuyerLastNameTH'}}
          />
        {/* ################### */}
        {/** Start ผู้ซื้อประกันภัย **/}
        {/* ################### */}
      </Fragment>
    );
  }

  _renderAssuredForm() {
    const { diffDateAssurance, step2 } = this.context;
    const regex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
    const {
      sIDNo,
      sSex,
      sInitNameTH,
      sFirstNameTH,
      sLastNameTH,
      sBirthDate,
      sOccupation,
      sMobile,
      sEmail,
      sStart_date,
      sEnd_date,
      onChangeModel,
      onChangeDateModel,
      sAssuranceFor,
    } = step2;
    const today = new Date(DateUtils.getCurrentPlusOneTh(null, "YYYY-MM-DD"));
    const insure_maxDate = new Date(
      moment(today)
        .add(1, "months")
        .format(DATETIME_SEARCH_FORMAT)
    );
    const maxDate = new Date(
      moment(today)
        .subtract(16, "years")
        .endOf('years')
        .format(DATETIME_SEARCH_FORMAT)
    );
    const minDate = new Date(
      moment(today)
        .subtract(65, "years")
        .startOf('years')
        .format(DATETIME_SEARCH_FORMAT)
    );
    const diffDate = sBirthDate
      ? moment.utc().diff(moment(sBirthDate), "years")
      : "-";
    const minEndDate = sStart_date
      ? new Date(DateUtils.getCurrentPlusOneTh(sStart_date, "YYYY-MM-DD"))
      : today;
    return (
      <>
        {/* ################## */}
        {/** Start - End Date **/}
        {/* ################## */}
        <div className="form-group">
          <div className="d-flex">
            <label>
            {this._getLang("insurancePeriod")}{" "}
              <InfoIconComponent id="insurancePeriod" text="วันที่เริ่มต้นความคุ้มครองต้องมากกว่าวันปัจจุบัน และเลือกล่วงหน้าได้ไม่เกิน 1 เดือน เวลาเริ่มต้น - สิ้นสุดความคุ้มครอง 16.30 น." />
            </label>
            <div className="ml-auto">
              <p className="text-dark-blue">
                <b>{diffDateAssurance}</b> ปี
              </p>
            </div>
          </div>
          <div className="d-flex">
            <DatePickerComponent
              minDate={today}
              maxDate={insure_maxDate}
              selected={sStart_date ? new Date(sStart_date) : ""}
              placeholderText="วันที่เริ่มต้น"
              onChange={date => onChangeDateModel(date)}
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              popperPlacement="top-start"
            />
            <SpaceBox />
            <DatePickerComponent
              className="disabled"
              disabled={true}
              minDate={minEndDate}
              selected={sEnd_date ? new Date(sEnd_date) : ""}
              placeholderText="วันที่สิ้นสุด"
              // onChange={date =>
              //   onChangeModel({ name: "sEnd_date", value: date })
              // }
              dateFormat="dd/MM/yyyy"
              popperPlacement="top-end"
              showTimeSelect={false}
            />
          </div>
        </div>
        {/* ################## */}
        {/*** End Date Picker **/}
        {/* ################## */}
        <div className="form-group">
          <label>{this._getLang("identity")}</label>
          <InputMask
            mask="9-9999-99999-99-9"
            maskChar="_"
            type="tel"
            value={sIDNo}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          >
            {inputProps => (
              <input
                id={sIDNo}
                {...inputProps}
                className="form-control"
                placeholder={this._getLang("identityPlaceHolder")}
                name="sIDNo"
              />
            )}
          </InputMask>
        </div>
        {/* ########################### */}
        {/** Start Gender Radio Button **/}
        {/* ########################### */}
        <div className="form-group">
          <label>{this._getLang("gender")}</label>
          <div className="d-flex">
            <div
              className={`radio-button align-item-center ${
                sSex === "M" ? "active" : ""
              }`}
              onClick={() => onChangeModel({ name: "sSex", value: "M" })}
            >
              <div className="radio" />
              <p>{this._getLang("male")}</p>
            </div>
            <div
              className={`radio-button align-item-center ${
                sSex === "F" ? "active" : ""
              }`}
              onClick={() => onChangeModel({ name: "sSex", value: "F" })}
            >
              <div className="radio" />
              <p>{this._getLang("female")}</p>
            </div>
          </div>
        </div>
        {/* ######################### */}
        {/** End Gender Radio Button **/}
        {/* ######################### */}
        {/* ################### */}
        {/** Start ผู้เอาประกันภัย **/}
        {/* ################### */}
        <NameThComponent
          keyIndex={""}
          label={sAssuranceFor && sAssuranceFor === 'other' ? "ชื่อ/นามสกุล ผู้เอาประกันภัย (ภาษาไทย)":"ชื่อ/นามสกุล (ภาษาไทย)"}
          titles={this._getTitles(sSex, "TH")}
          sInitNameTH={sInitNameTH}
          sFirstNameTH={sFirstNameTH}
          sLastNameTH={sLastNameTH}
          onChange={onChangeModel}
        />
        {/* ############################ */}
        {/** Start ผู้เอาประกันภัย **/}
        {/* ############################ */}
        <div className="form-group">
          <div className="d-flex">
            <label>{this._getLang("birthdate")}</label>
            <div className="ml-auto">
              <p className="text-dark-blue">
                <b>{diffDate} </b>
                {this._getLang("year")}
              </p>
            </div>
          </div>
          <DatePickerComponent
            selected={sBirthDate ? new Date(sBirthDate) : ""}
            minDate={minDate}
            maxDate={maxDate}
            datePrevious={60}
            placeholderText={this._getLang("birthdate")}
            onChange={date =>
              onChangeModel({ name: "sBirthDate", value: date })
            }
            dateFormat="dd/MM/yyyy"
            showTimeSelect={false}
            showMonthYearDropdown
            popperPlacement="top-start"
          />
        </div>
        <div className="form-group">
          <label>{this._getLang("ocupationPlaceHolder")}</label>
          <SelectComponent
            placeholder={this._getLang("ocupationPlaceHolder")}
            options={this.state.occupations}
            selected={sOccupation}
            onChange={this._onSelectOccupation}
            // onChange={selected =>
            //   onChangeModel({ name: "sOccupation", value: selected })
            // }
          />
        </div>
        <div className="form-group">
          <label>{this._getLang("contact")}</label>
          <InputMask
            mask="9999999999"
            type="tel"
            value={sMobile}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          >
            {inputProps => (
              <input
                id={sMobile}
                {...inputProps}
                className="form-control"
                placeholder={this._getLang("contactPlaceHolder")}
                name="sMobile"
              />
            )}
          </InputMask>
        </div>
        <div className="form-group">
          <label>{this._getLang("email")}</label>
          <input
            id={sEmail}
            type="text"
            className="form-control"
            placeholder="name@email.com"
            name="sEmail"
            value={sEmail}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        </>
    )
  }
  _renderAddressForm() {
    const { step2 } = this.context;
    const {
      sNo,
      sMoo,
      sSoi,
      sRoad,
      sProvince,
      sDistrict,
      sCity,
      sZipcode,
      onChangeModel,
      sBuilding,
      onChangeModelProvinces
    } = step2;

    return (
      <Fragment>
        <div className="form-group d-flex">
          <input
            // id={sNo}
            type="text"
            className="form-control"
            placeholder={this._getLang("no")}
            name="sNo"
            value={sNo}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            // id={sMoo}
            type="text"
            className="form-control"
            placeholder={this._getLang("moo")}
            name="sMoo"
            value={sMoo}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group d-flex">
          <input
            // id={sBuilding}
            type="text"
            className="form-control"
            placeholder={this._getLang("buildingVillage")}
            name="sBuilding"
            value={sBuilding}
            onChange={(e) =>
              onChangeModel({name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group d-flex">
          <input
            // id={sSoi}
            type="text"
            className="form-control"
            placeholder={this._getLang("soi")}
            name="sSoi"
            value={sSoi}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            // id={sRoad}
            type="text"
            className="form-control"
            placeholder={this._getLang("road")}
            name="sRoad"
            value={sRoad}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <ProvincesComponent
            lang={"th"}
            langague={Step3Langague}
            provinces={{ sProvince, sDistrict, sCity, sZipcode }}
            onChange={object => onChangeModelProvinces(object)}
          />
        </div>
      </Fragment>
    );
  }

  _renderPersonalBenefit(person, key) {
    const { benefitTitles } = this.state;
    const { step2 } = this.context;
    const { onChangeBenefit } = step2;
    const { sInit, sFirstName, sLastName, sRelation } = person;

    return (
      <Fragment>
        <div className="form-group">
          <label>
          ชื่อ/นามสกุล (ภาษาไทย)
          </label>
          <SelectComponent
            placeholder="คำนำหน้าชื่อ"
            options={benefitTitles}
            selected={sInit}
            onChange={selected =>
              onChangeBenefit({ key, name: "sInit", value: selected })
            }
          />
          <InputMask
            mask="********************"
            maskChar=''
            formatChars={{
              '*': '[\u0E00-\u0E7Fก-ฮ]',
            }}
            permanents={[2, 5]}
            type="text"
            value={sFirstName}
            onChange={e =>
              onChangeBenefit({
                key,
                name: e.target.name,
                value: e.target.value
              })
            }
          >
            {inputProps => (
              <input
                id={`sFirstName}`}
                {...inputProps}
                className="form-control mt-2"
                placeholder="ชื่อ"
                name="sFirstName"
              />
            )}
          </InputMask>
          <InputMask
            mask="********************"
            maskChar=''
            formatChars={{
              '*': '[\u0E00-\u0E7Fก-ฮ]',
            }}
            permanents={[2, 5]}
            type="text"
            value={sLastName}
            onChange={e =>
              onChangeBenefit({
                key,
                name: e.target.name,
                value: e.target.value
              })
            }
          >
            {inputProps => (
              <input
                id={`sLastName`}
                {...inputProps}
                className="form-control mt-2"
                placeholder="นามสกุล"
                name="sLastName"
              />
            )}
          </InputMask>
          
        </div>
        <div className="form-group">
          <label>ความสัมพันธ์</label>
          <SelectComponent
            placeholder="โปรดเลือก"
            options={RELATIONS}
            selected={sRelation}
            onChange={selected =>
              onChangeBenefit({ key, name: "sRelation", value: selected })
            }
          />
        </div>
      </Fragment>
    );
  }

  _SpaceBox() {
    return <SpaceBox w={"14px"} />;
  }
  render() {
    const { step2 } = this.context;
    const {
      acceptHealth,
      benefits,
      onChangeModel,
      onAddBenefit,
      onRemoveBenefit,
      sAssuranceFor,
      Answer1_1,
      Answer1_2,
      Answer3,
      Answer4,
      Answer5
    } = step2;
    const benefitCount = benefits ? benefits.length : 1;

    return (
      <Fragment>
        <div className="form-wrapper">{this._renderRelationForm()}</div>
        { sAssuranceFor && sAssuranceFor === 'other' && (
          <>
            <div className="form-group address-header mb-0">
              <label>ข้อมูลผู้ซื้อประกันภัย</label>
            </div>
            <div className="form-wrapper">{this._renderBuyerForm()}</div> 
          </>
        )}
        <div className="form-group address-header mb-0">
          <label>ข้อมูลผู้เอาประกันภัย</label>
        </div>
        <div className="form-wrapper">{this._renderAssuredForm()}</div> 
        <div className="form-group address-header mb-0">
          <label>ที่อยู่ผู้เอาประกันและจัดส่งกรมธรรม์</label>
        </div>
        <div className="form-wrapper">{this._renderAddressForm()}</div>
        <Fragment>
          {benefits &&
            benefits.map((person, indexIn) => {
              return (
                <Fragment key={indexIn}>
                  <div className="form-group address-header mb-0">
                    <label>ผู้รับประโยชน์ {indexIn + 1} </label>
                  </div>
                  <div className="form-wrapper">
                    {this._renderPersonalBenefit(person, indexIn)}
                  </div>
                </Fragment>
              );
            })}
          <div className="form-wrapper">
            <div className="form-group benefit-wrapper">
              {benefitCount === 1 ? (
                <button
                  className="btn btn-seconday m-auto d-flex"
                  onClick={() => onAddBenefit()}
                >
                  <p>เพิ่มผู้รับประโยชน์</p>{" "}
                  <img src={AddRound} width="24px" height="24px" />
                </button>
              ) : benefitCount === 2 ? (
                <button
                  className="btn btn-seconday m-auto d-flex"
                  onClick={() => onRemoveBenefit()}
                >
                  <p>ลบผู้รับประโยชน์</p>{" "}
                  <img src={DelRound} width="24px" height="24px" />
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        </Fragment>
        <div className="form-group address-header">
          <label>คำถามสุขภาพ</label>
        </div>
        <div className="form-wrapper">
          <CheckBoxHealth
            // checked={acceptHealth}
            CheckBox={{ Answer1_1, Answer1_2, Answer3, Answer4, Answer5 }}
            onChange={onChangeModel}
            onCheckFirst={checked =>
              onChangeModel({ name: "Question1", value: checked })
            }
            onCheckSecond={checked =>
              onChangeModel({ name: "Question2", value: checked })
            }
            onCheckThird={checked =>
              onChangeModel({ name: "Question3", value: checked })
            }
            onCheckForth={checked =>
              onChangeModel({ name: "Question4", value: checked })
            }
            onCheckFifth={checked =>
              onChangeModel({ name: "Question5", value: checked })
            }
          />
        </div>
      </Fragment>
    );
  }
}

PersonalStep2.contextType = PersonalContext;
export default withRouter(PersonalStep2);
